import { DOWNLOADFILE, GET } from "../../API/get";

export const fetchJobsheetContent = async (job_id) => {
    const response = await GET(`job/jobsheet/content/${job_id}`);
    return response.status === "Success" ? response : null;
}

export const downloadJobsheet = async (job_id) => {
    await DOWNLOADFILE(`job-sheet/download/${job_id}`);
}